import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable, { MTableAction } from "material-table";
import {IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Button} from '@material-ui/core';
import AddButton from './AddButton';




const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export  function ListOfPaySystem(props) {

    const classes = useStyles();

    const { show, data,  addPaySys } = props;

    const tableRef = React.createRef();
    const addActionRef = React.useRef();

    const columns = [
        {title: "Установа", field:"bank_name"}, 
        {title:"ЄДРПОУ", field:"edrpou"},
        {title:"Контактна особа", field:"contacts"},
        {title:"Ідентифікатор установи", field: "banc_ident"},
        {title:"Публічний ключ банку", field:"inn"},
        {title:"Публічний ключ системи", field:"email"},
        {title:"Статус", field: "status"}
    ];

    const [template_data, setTableData] = useState(data.data);
    
    const [initDataState, setInitDataState] = useState(false);

    const [display, setShow] = useState(false);

    useEffect(()=>{ setTableData(data.data); setShow(show)}, [data.data, show])

    const addNewUser = ()=>{
      addPaySys(true);
    }

    if(!display) return null;

    return (
      <div style={{ maxWidth: "100%" }}>
        <div><Button onClick={addNewUser}>Додати нову установу </Button></div>
        <MaterialTable
          tableRef={tableRef}
          columns={columns}
          data={template_data}
          title="Банківські установи"
          components={{
            Action: props=><AddButton {...props} />
          }}

          icons={
            { Add: ()=> <IconButton onClick={()=>{}} />}
          }

          actions={[
            {
              icon: "edit",
              tooltip: "редагувати інформацію",
              onClick: (event, rowData) => alert(`Редагувати ${rowData.name_last}`)
            }
          ]}
          editable={{
            onRowAdd: (newData) =>
              Promise.resolve(setTableData([...template_data, newData]))
          }}
        />
      </div>
    );

}